import React from 'react';
import './MartFooter.css';

const MartFooter = () => {
  return (
    <footer className="mf-root">
      {/* JOIN COMMUNITY SECTION */}
      <div className="mf-newsletter">
        <div className="mf-news-content">
          <h3>Join the ATR Mart Community</h3>
          <p>Get exclusive early access to tech deals and seasonal fashion offers.</p>
        </div>
        <div className="mf-news-form">
          <input type="email" placeholder="Enter your email address" />
          <button className="mf-btn-subscribe">Subscribe Now</button>
        </div>
      </div>

      <div className="mf-main-content">
        <div className="mf-brand-col">
          <h2 className="mf-logo">ATR MART</h2>
          <p className="mf-tagline">
            Your premium destination for electronics, lifestyle, and home goods. 
            Delivering quality from Madurai to the world.
          </p>
          <div className="mf-contact-card">
            <span className="mf-contact-label">Customer Care</span>
            <span className="mf-contact-num">+91 93444 53444</span>
          </div>
        </div>

        <div className="mf-link-col">
          <h4>Explore</h4>
          <ul>
            <li>Marketplace</li>
            <li>Become a Seller</li>
            <li>Featured Brands</li>
            <li>New Arrivals</li>
          </ul>
        </div>

        <div className="mf-link-col">
          <h4>Trust Center</h4>
          <ul>
            <li>Privacy Policy</li>
            <li>Terms & Conditions</li>
            <li>Refund Policy</li>
            <li>Shipping Policy</li>
          </ul>
        </div>

        <div className="mf-link-col">
          <h4>Corporate Office</h4>
          <address>
            ATR MART,<br />
            12A, Vaigai Nagar 2nd Street,<br />
            Madurai, 625017
          </address>
        </div>
      </div>

      <div className="mf-bottom-bar">
        <p>© 2026 ATR MART. ATR Group.</p>
        <div className="mf-payments">
          <span>UPI</span> • <span>VISA</span> • <span>COD</span>
        </div>
      </div>
    </footer>
  );
};

export default MartFooter;